module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gold-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "gold-sub-title ta-c"
  }, [_c('span', [_vm._v("—— ")]), _c('span', [_vm._v(_vm._s(_vm.goldStates.subTitle))]), _c('span', [_vm._v(" ——")])]), _vm._v(" "), _c('div', {
    staticClass: "gold-amount ta-c"
  }, [_c('span', {
    staticClass: "money-icon"
  }), _vm._v(_vm._s(_vm.goldAmount))]), _vm._v(" "), _c('div', {
    staticClass: "gold-slogen"
  }, [_c('h5', {
    staticClass: "ta-c"
  }, [_vm._v(_vm._s(_vm.goldStates.slogenText))]), _c('h6', {
    staticClass: "ta-c"
  }, [_vm._v("\n        " + _vm._s(_vm.goldStates.slogenSubText))])]), _vm._v(" "), _c('a', {
    staticClass: "gold-btn block",
    attrs: {
      "href": _vm.goldStates.btnHref,
      "clstag": "pageclick|keycount|jieqian|jintiao|url"
    }
  }, [_vm._v(_vm._s(_vm.goldStates.btnText))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gold-logo ta-c"
  }, [_c('img', {
    staticClass: "h100",
    attrs: {
      "src": require("../assets/css-img/gold-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7b6a1db6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gold-head.vue
// module id = 24
// module chunks = 0